import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import Logo from '../Logo';

export default function ProtectedRoute({ children, requiredRole }) {
  const { auth, loading } = useAuth();

  if (loading) {
    return (
      <div style={{
        minHeight: '100vh', display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'center',
        background: 'var(--gray-50)', fontFamily: 'var(--font)',
      }}>
        <div style={{ marginBottom: 12 }}><Logo size={44} /></div>
        <p style={{ color: 'var(--gray-400)', fontSize: 15 }}>Loading…</p>
      </div>
    );
  }

  if (!auth) return <Navigate to="/admin/login" replace />;
  if (requiredRole && auth.role !== requiredRole) return <Navigate to="/admin/login" replace />;

  return children;
}
